"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fetch_1 = require("./fetch");
// import createAxios from "./axios"
const axiosinterceptors_1 = require("./axiosinterceptors");
exports.default = {
    fetch: fetch_1.default,
    axiosinterceptors: axiosinterceptors_1.default
};
